import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import AnneeScolaireUpdate from './annee-scolaire-update';
import AnneeScolaireDetail from './annee-scolaire-details';
import AnneeScolaires from './annee-scolaire';
import AnneeScolaireDelete from './annee-scolaire-delete';
import AnneeScolaireClotureModal from './annee-scolaire-cloture';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/details`} component={AnneeScolaireDetail} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid`} component={AnneeScolaires} />
    </Switch>
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/new`} component={AnneeScolaireUpdate} />
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/edit`} component={AnneeScolaireUpdate} />
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/delete`} component={AnneeScolaireDelete} />
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/cloture`} component={AnneeScolaireClotureModal} />
  </>
);

export default Routes;
